import { Fragment } from "react";
import Cards from "@particles/card/templates/TemplateEv2/components/Cards";
import { TemplateProps } from "@particles/card/utils/types";

type TemplateEv2Props = {
  /** The component to put in the last item. */
  lastComponent?: React.ReactElement;
} & TemplateProps;

/**
 * Template E variant 2, initially used for Campaign Template 3 - Asean Insights.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=20436-71341&m=dev
 */
const TemplateEv2 = ({
  cardProps,
  className,
  header,
  lastComponent,
}: TemplateEv2Props): React.ReactElement | null => {
  if (!cardProps.length) return null;

  return (
    <section data-testid="template-e-v2-component" className={className}>
      {header}

      <div className="grid w-full gap-8 lg:grid-cols-12">
        {cardProps
          .slice(0, 4) // Must only return maximum of 4 articles.
          .map((cardProps, index) => {
            return (
              <Fragment key={cardProps.id}>
                <Cards cardProps={cardProps} index={index} />

                {index === 3 ? lastComponent : null}
              </Fragment>
            );
          })}
      </div>
    </section>
  );
};

export default TemplateEv2;
